import { createSlice } from "@reduxjs/toolkit";

const { loadWarningOmissions } = require("./warning-selection-local-storage");

const initialState = { list: loadWarningOmissions() };

const WarningOmissionsSlice = createSlice({
  name: "warning-omissions",
  initialState,
  reducers: {
    omitWarning(state, action) {
      const { id } = action.payload;
      state.list = [id, ...state.list];
    },
  },
});

export const WarningOmissionsReducer = WarningOmissionsSlice.reducer;

const { omitWarning } = WarningOmissionsSlice.actions;

export const WarningOmissionsActions = {
  omitWarning,
};
